import { Menu, UnstyledButton } from '@mantine/core'
import { subMonths } from 'date-fns'
import React, { useState } from 'react'

import optionIcon from '../../../icones/iconesVersaoVerde/opcoes.svg'
import ActionIcon from '../ActionIcon'
import Botao from '../Botao'
import DatePicker from '../DatePicker'
import Group from '../Group'
import RadioInput from '../Radio'

import * as S from './styles'

const DEFAULT_DATA = { start: null, stop: null }

export default function MenuOption({
  onClick,
  options,
  scaleIcon,
  offset = 5
}) {
  const [selectedDate, setSelectedDate] = useState(DEFAULT_DATA)
  const [selected, setSelected] = useState('24h')
  const [menuOpened, setMenuOpened] = useState(false)

  const today = new Date()
  const minDatePeriodo = subMonths(today, 3)

  const isPeriodo = selected === 'periodo'

  const handleSelectedDate = (field, value) => {
    setSelectedDate((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  const handleClick = () => {
    if (!isPeriodo) {
      setSelectedDate({ ...DEFAULT_DATA })
    }

    onClick({
      type: selected,
      ...(isPeriodo && { period: selectedDate })
    })

    setMenuOpened(false)
  }

  return (
    <S.Menu
      opened={menuOpened}
      onChange={setMenuOpened}
      position="bottom-end"
      closeOnItemClick={false}
      shadow="md"
      width={250}
      radius="md"
      offset={offset}
    >
      <Menu.Target>
        <UnstyledButton>
          <ActionIcon
            scaleIcon={scaleIcon}
            alt="optionIcon"
            variant="transparent"
            icon={optionIcon}
          />
        </UnstyledButton>
      </Menu.Target>
      <S.MenuDropdown>
        <S.MenuItens>
          <S.RadioGroup value={selected} onChange={setSelected}>
            {options.map((section) => (
              <S.DatePickerRadio key={section.value}>
                <RadioInput value={section.value} label={section.label} />
                {section.inputFields
                  ? section.inputFields.fields.map((field) => (
                      <DatePicker
                        key={field.value}
                        withinPortal={false}
                        minDate={
                          field.value === 'start'
                            ? minDatePeriodo
                            : selectedDate.start
                        }
                        maxDate={today}
                        prefixo={field.label}
                        value={selectedDate[field.value]}
                        onChange={(date) => {
                          setSelected(section.value)
                          handleSelectedDate(field.value, date)
                        }}
                      />
                    ))
                  : null}
              </S.DatePickerRadio>
            ))}
          </S.RadioGroup>
        </S.MenuItens>
        <Group position="center">
          <Botao
            disabled={isPeriodo && (!selectedDate.start || !selectedDate.stop)}
            label="Carregar"
            onClick={handleClick}
          />
        </Group>
      </S.MenuDropdown>
    </S.Menu>
  )
}
